import api from './request'

const logPrinterResultList = (printerResultList) => {
    return api.postPromise('sls/logPrinterResultList', {}, printerResultList)
}

const findPrinterResultList = (startTime, endTime, waybillId) => {
    return api.getPromise('sls/findPrinterResultList', {startTime, endTime, waybillId})
}

const logJsError = (logDto) => {
    return api.postPromise('sls/logJsError', {}, logDto)
}

export default {
    logPrinterResultList,
    findPrinterResultList,
    logJsError
}



// WEBPACK FOOTER //
// ./src/request/slsApi.js